import { CustomerDecisionOptionsType, ProductItem, ExpectedAlternativeProductData } from "./AlternativeOfferModal";
import { CustomerChangeDecisionCard } from "./CustomerChangeDecisionCard";
import { AlternativeProductOfferContainer } from "./AlternativeProductOfferContainer";
import { NoSuitableAlternativeContainer } from "./NoSuitableAlternativeContainer";
import { NonAlternativeContainer } from "./NonAlternativeContainer";
import { WAIT_CUSTOMER_DECISION } from "../../../utils/consts";

type Props = {
    costumerSelectedChoice: {
        originalProductItemID: number;
        alternativeDecision: CustomerDecisionOptionsType;
    }
    onCustomerChoiceChange: (originalProductItemID: number, alternativeProductItemID: CustomerDecisionOptionsType) => void;
    originalProduct: ProductItem;
    alterantiveProduct: ExpectedAlternativeProductData;
    hasMultipleOutOfStockProducts: boolean;
    treatAsMultipleProductsOrder: boolean;
    orderStatus: string;
}

export const OfferContainer: React.FC<Props> = ({ 
    costumerSelectedChoice, 
    onCustomerChoiceChange, 
    originalProduct, 
    alterantiveProduct,
    hasMultipleOutOfStockProducts,
    treatAsMultipleProductsOrder,
    orderStatus
}) => {
    const customerSelection = costumerSelectedChoice.alternativeDecision;
    const showDecisionCard = (hasMultipleOutOfStockProducts || orderStatus === WAIT_CUSTOMER_DECISION) && customerSelection !== null;
    const isOutOfStockFlow = orderStatus === WAIT_CUSTOMER_DECISION;

    return (
        showDecisionCard ? (
            <CustomerChangeDecisionCard
                customerSelection={customerSelection}
                onCustomerChoiceChange={onCustomerChoiceChange}
                originalProduct={originalProduct}
                alterantiveProduct={alterantiveProduct}
                isOutOfStockFlow={isOutOfStockFlow}
            />
        ) : alterantiveProduct !== null ? (
            <AlternativeProductOfferContainer
                onCustomerChoiceChange={onCustomerChoiceChange}
                originalProduct={originalProduct}
                alterantiveProduct={alterantiveProduct}
            />
        ) : isOutOfStockFlow ? (
            <NonAlternativeContainer
                onCustomerChoiceChange={onCustomerChoiceChange}
                originalProduct={originalProduct}
                treatAsMultipleProductsOrder={hasMultipleOutOfStockProducts}
            />
        ) : (
            <NoSuitableAlternativeContainer
                onCustomerChoiceChange={onCustomerChoiceChange}
                originalProduct={originalProduct}
                treatAsMultipleProductsOrder={treatAsMultipleProductsOrder}
            />
        )
    );
}   
